/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IApiGridScope extends angular.IScope {
        processId: string;
        processConfigurationId: string;
        apiGridConfiguration: Wars.Domain.Model.ApiGridConfiguration;
        apiRows: any;
        filteredRows: any;
        formData: any;
        fieldUniqueId: string;
        selectionChanged: any;
        checkboxChanged: any;
        isConfigureMode: boolean;
        sortColumn: any;
        sort: any;
        filterChanged: any;
        filter: any;
        getClockValue:any;
        runSystemAction: any;
        hideSection: boolean;
        openSystemActionConfirmation: any;
        closeSystemActionConfirmation: any;
    }

    export class ApiGrid implements IDirective {
        public constructor(private upload: any, private $timeout: angular.ITimeoutService, private formDataService: services.FormDataService) {

        }

        public link($scope: IApiGridScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/apiGrid.html";
        public restrict: string = "E";
        public controller = ["$scope", '$rootScope', 'apiGridService','timeTrackerService','processService', ApiGridController];
        public controllerAs = "controller";
        public scope: any = {
            processId: "=",
            apiGridConfiguration: "=",
            processConfigurationId: "=",
            formData: "=",
            fieldUniqueId: "=",
            selectionChanged: "=",
            isConfigureMode: "=",
            hideSection: "=",
            isReadonly: "="
        };
    }


    export class ApiGridController {
        constructor(private $scope: IApiGridScope, private $rootScope: angular.IRootScopeService, private apiGridService: services.ApiGridService, private timeTrackerService: services.TimeTrackerService,
        private processService:services.ProcessService) {
            $scope.checkboxChanged = (r) => this.checkboxChanged(r);
            $scope.sortColumn = (c) => this.sort(c);
            $scope.filterChanged = (c) => this.filterChanged(c);
            $scope.filter = {};
            $scope.getClockValue = (c) => this.getClockValue(c);
            $scope.runSystemAction = (s, p) => this.runSystemAction(s, p);
            $scope.openSystemActionConfirmation = (a, c, p) => this.openSystemActionConfirmation(a, c, p);
            $scope.closeSystemActionConfirmation = (a) => this.closeSystemActionConfirmation(a);

            //console.log(this.$scope.apiGridConfiguration);

            $scope.sort = {
                column: "",
                descending: false
            };


            if (!this.$scope.isConfigureMode) {
                //listen for the broadcast from form clear to remove the user bound to the picker
                var cb = $rootScope.$on('RefreshApiGrid',
                    (event, data) => {
                        if (this.$scope.apiGridConfiguration.objectQuery.myInputObjectSchema != null &&
                            this.$scope.apiGridConfiguration.objectQuery.myInputObjectSchema.properties.length === 1 &&
                            this.$scope.apiGridConfiguration.objectQuery.myInputObjectSchema.properties[0].propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessId) {
                            if (data === this.$scope.apiGridConfiguration.id) {
                                this.getGridResults();        
                            }
                        } 
                    });
                //destroy the listener on scope destroy to avoid memory leak
                $scope.$on("$destroy",
                    () => {
                        cb();
                    });
                this.getGridResults();
                
            }
        }

        private getGridResults() {
            this.apiGridService.getApiGridResult(
                this.$scope.processId,
                this.$scope.processConfigurationId,
                this.$scope.apiGridConfiguration.id,
                this.$scope.fieldUniqueId
                ).then(rows => {

                var processIdColumn = Enumerable.from(this.$scope.apiGridConfiguration.columns)
                    .singleOrDefault(c => c.name == "_ProcessId");

                if (this.$scope.formData) {
                    var dataArray = this.$scope.formData[this.$scope.fieldUniqueId];
                    if (!dataArray) {
                        dataArray = [];
                    }
                    rows.forEach(r => {
                        dataArray.forEach(element => {
                            if (r[processIdColumn.schemaPropertyUniqueId] === element) {
                                r.isSelected = true;
                            }
                        });
                    });

                    var itemsToRemove = [];
                    dataArray.forEach(e => {
                        if (!Enumerable.from(rows).any(r => r[processIdColumn.schemaPropertyUniqueId] === e)) {
                            itemsToRemove.push(e);
                        }
                    });

                    if (itemsToRemove.length > 0) {
                        itemsToRemove.forEach(i => {
                            dataArray.remove(i);
                        });

                        if (this.$scope.selectionChanged) {
                            this.$scope.selectionChanged();
                        }
                    }
                }
                

                rows.forEach(r => {
                    if (!r['_processId'] && processIdColumn) {
                        r['_processId'] = r[processIdColumn.schemaPropertyUniqueId];
                    }
                });

                this.$scope.apiRows = rows;
                //console.log(rows);
                this.$scope.filteredRows = rows;

                if (!rows || rows.length == 0) {
                    //this.$scope.hideSection = true;
                } else {
                    this.$scope.hideSection =false; 
                }
            });
        }

        private runSystemAction(systemActionId:string,processId: string) {
            this.processService.runSystemAction(processId, systemActionId).then(r => {
                this.getGridResults();
            });
        }

        private openSystemActionConfirmation(apiGridConfig: any, column: any, processId: any) {
            apiGridConfig.showConfirm = true;
            apiGridConfig.actionColumn = column;
            apiGridConfig.actionProcessId = processId;
        }

        private closeSystemActionConfirmation(apiGridConfig: any) {
            apiGridConfig.showConfirm = false;
            apiGridConfig.actionColumn = null;
            apiGridConfig.actionProcessId = null;
        }

        private sort(column: string) {
            var sort = this.$scope.sort;

            if (sort.column == column) {
                sort.descending = !sort.descending;
            } else {
                sort.column = column;
                sort.descending = false;
            }

            var isDateTimeColumn = Enumerable.from(this.$scope.filteredRows).any(x => x[column].isDateTime);

            if (sort.descending) {
                if (isDateTimeColumn) {
                    this.$scope.filteredRows = Enumerable.from(this.$scope.filteredRows).orderBy(x => x[column].dateTimeValue).toArray();
                } else {
                    this.$scope.filteredRows = Enumerable.from(this.$scope.filteredRows).orderBy(x => x[column]).toArray();
                }
            } else {
                if (isDateTimeColumn) {
                    this.$scope.filteredRows = Enumerable.from(this.$scope.filteredRows).orderByDescending(x => x[column].dateTimeValue).toArray();
                } else {
                    this.$scope.filteredRows = Enumerable.from(this.$scope.filteredRows).orderByDescending(x => x[column]).toArray();
                }
            }
        }

        private filterChanged(uniqueId: string) {
            let isFirst = true;
            let rows = this.$scope.apiRows;

            for (var propName in this.$scope.filter) {
                if (this.$scope.filter[propName]) {
                    rows = Enumerable.from(rows).where(r => new String(<any>r[propName]).toLowerCase().startsWith((<string>this.$scope.filter[propName]).toLowerCase())).toArray();
                }
            }
            this.$scope.filteredRows = rows;
        }

        private checkboxChanged(row) {
            var dataArray = this.$scope.formData[this.$scope.fieldUniqueId];

            if (!dataArray) {
                dataArray = [];
            }

            if (row.isSelected) {
                dataArray = dataArray.filter(processId => {
                    return row._processId !== processId;
                });
                dataArray.push(row._processId);
            }
            else {
                dataArray = dataArray.filter(processId => {
                    return row._processId !== processId;
                });
            }

            this.$scope.formData[this.$scope.fieldUniqueId] = dataArray;
            if (this.$scope.selectionChanged) {
                this.$scope.selectionChanged();
            }

            //console.log(dataArray);
        }

        private getClockValue(clockJson: any) {
            return this.timeTrackerService.getTimeTrackerStringValue(clockJson);
        }
    }

}
warsApp.registerDirective('ApiGrid', []);